import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  "class": "footer px-4"
};
var _hoisted_2 = {
  "class": "row align-items-center justify-content-lg-between"
};
var _hoisted_3 = {
  "class": "col-lg-6"
};
var _hoisted_4 = {
  "class": "copyright text-center text-lg-left text-muted"
};

var _hoisted_5 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.boylikegirl.club",
  "class": "font-weight-bold ml-1",
  target: "_blank"
}, "Copyright Boylikegirl", -1);

var _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  "class": "col-lg-6"
}, null, -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("footer", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createTextVNode(" © " + _toDisplayString($data.year) + " ", 1), _hoisted_5])]), _hoisted_6])]);
}